export const GETMEASBYTYPEID_EXCEPTION =
    '[mea][getMeasByTypeId]: Param id must be a number and greater than 0';

export const getMeasByTypeId = (state, id) => {
    if (!id || id < 1) {
        throw new Error(GETMEASBYTYPEID_EXCEPTION);
    }
    return state.mea[id] ? state.mea[id].meas : {};
};

export const getMeasListByTypeId = (state, id) => Object.values(getMeasByTypeId(state, id));



// WEBPACK FOOTER //
// ./src/services/mea/selector.js